import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import clsx from 'clsx';
import styles from './ChartPreview.module.scss';

const plugins = [{
  id: 'currentLinePreview',
  afterDraw: (chart: any, _, options: any) => {
    // if (!options?.lineValue) return null
    const { ctx } = chart;
    const {
      bottom, top, max, min,
    } = chart.scales.y
    const curY = bottom - ((bottom - top) * ((options.lineValue - min) / (max - min)))
    ctx.save();
    ctx.setLineDash([8, 4]);
    ctx.beginPath();
    ctx.moveTo(0, curY);
    ctx.lineTo(chart.canvas.width, curY);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.2)';
    ctx.stroke();
    ctx.setLineDash([])
    ctx.restore();
    return null
  },
}]

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
);

function Chart({
  className,
  data,
  lastPrice,
  fall,
}: {
  className?: string,
  data: any[],
  lastPrice?: number,
  fall?: boolean
}) {
  if (!data?.length || (data?.length < 2)) return null

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      currentLinePreview: {
        lineValue: lastPrice,
      },
    },
    tooltips: {
      enabled: false,
    },
    scales: {
      y: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
          drawTicks: false,
        },
        border: {
          display: false,
        },
      },
      x: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
          drawTicks: false,
        },
        border: {
          display: false,
        },
      },
    },
  };

  const labels = data.map(() => (
    ''
  ));

  const borderColor = !fall ? '#6FD964' : '#FF4D30'

  const chartData = {
    labels,
    datasets: [
      {
        data: data.map((v) => v.close),
        borderWidth: 1,
        borderColor,
        fill: false,
        pointRadius: 0,
      },
    ],
  };

  return (
    <div className={clsx(styles.container, className)}>
      <Line
        // @ts-ignore
        options={options}
        data={chartData}
        plugins={plugins}
      />
    </div>
  )
}
export default Chart
